import { Typography } from "antd";
import { useTranslation } from "react-i18next";

const SingleAppCardDesktop = ({ app, handleClick }) => {
    const { t } = useTranslation();
    const description = t(`apps.${app.value}.long_description`);

    return (
        <div
            onClick={() => handleClick(app)}
            style={{
                padding: "20px",
                cursor: "pointer",
                display: "flex",
                width: "100%",
                display: "flex",
                gap: "10px",
            }}>
            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    height: "200px",
                }}>
                <div
                    style={{
                        width: "200px",
                    }}>
                    <img src={app.img} style={{ width: "100%", height: "auto" }} />
                </div>
            </div>
            <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
                <div>
                    <Typography.Title level={4}>{app.label}</Typography.Title>
                    <p>{description}</p>
                </div>
            </div>
        </div>
    );
};

export { SingleAppCardDesktop };
